import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = "https://api-inventory.neuromotion.tech/api/v1/manage";

export const getPurchaseCart = createAsyncThunk(
  "manage/getPurchaseCart",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/getpurchasecart`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const payForPurchase = createAsyncThunk(
  "manage/payForPurchase",
  async (payData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/paypurchase`, payData);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const addPurchaseCart = createAsyncThunk(
  "manage/addPurchaseCart",
  async (stockData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_URL}/addPurchaseCart`,
        stockData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Set content type for file uploads
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const clearPurchaseBill = createAsyncThunk(
  "manage/clearPurchaseBill",
  async (clearBilldata, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${API_URL}/clearbill`, clearBilldata, {
        headers: {
          "Content-Type": "multipart/form-data", // Set content type for file uploads
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const EditPurchaseCart = createAsyncThunk(
  "manage/EditPurchaseCart",
  async (stockData, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${API_URL}/editPurchaseCart`,
        stockData,
        {
          headers: {
            "Content-Type": "multipart/form-data", // Set content type for file uploads
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const deletePurchaseCart = createAsyncThunk(
  "product/deletePurchaseCart",
  async (deletedID, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_URL}/${deletedID}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
export const purchaseHistory = createAsyncThunk(
  "manage/purchaseHistory",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${API_URL}/purchasehistory`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

const manageProductSlice = createSlice({
  name: "manageproduct",
  initialState: {
    purchasecart: null,
    purchasehistory: null,
    loading: false,
    error: null,
    message: false,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearMessage: (state) => {
      state.message = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(addPurchaseCart.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(addPurchaseCart.fulfilled, (state) => {
      state.loading = false;
      state.message = "Product Add Successfuly";
    });
    builder.addCase(addPurchaseCart.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(getPurchaseCart.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getPurchaseCart.fulfilled, (state, action) => {
      state.loading = false;
      state.purchasecart = action.payload.purchasecart;
    });
    builder.addCase(getPurchaseCart.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(deletePurchaseCart.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(deletePurchaseCart.fulfilled, (state, action) => {
      state.loading = false;
      state.message = "Remove from order succesfully";
    });
    builder.addCase(deletePurchaseCart.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(EditPurchaseCart.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(EditPurchaseCart.fulfilled, (state, action) => {
      state.loading = false;
      state.message = "Edit succesfully";
    });
    builder.addCase(EditPurchaseCart.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(payForPurchase.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(payForPurchase.fulfilled, (state, action) => {
      state.loading = false;
      state.message = "Save order status succesfully";
    });
    builder.addCase(payForPurchase.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(purchaseHistory.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(purchaseHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.purchasehistory = action.payload.purchasehistory;
    });
    builder.addCase(purchaseHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
    builder.addCase(clearPurchaseBill.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(clearPurchaseBill.fulfilled, (state, action) => {
      state.loading = false;
      state.message = action.payload.message;
    });
    builder.addCase(clearPurchaseBill.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.error;
    });
  },
});
export const { clearError, clearMessage } = manageProductSlice.actions;

export default manageProductSlice.reducer;
